<template>
  <BootstrapModal class="AddTranslation"
    v-on="$listeners"

    @save="saveTranslation"
    @close="close"
  >
    <div>
      <FormSelect v-model="$v.lang.$model"
        class="sm form-element"
        id="lang"
        label="Lang"

        :options="translationOptions"
      />

      <FormInput
        class="form-element"
        v-model="$v.name.$model"

        id="name"
        :label="simpleTranslationPlaceholder || 'Naam'"

        :vuelidate="$v"
        fieldName="name"
      />
      <template v-if="!simpleTranslation">
        <FormTextarea v-model="$v.short_description.$model" class="last-fields"
          id="short_description"
          label="Korte beschrijving"

          :vuelidate="$v"
          fieldName="short_description"
        />
        <FormRichText v-if="show" v-model="$v.description.$model"
          id="long_description"
          label="Omschrijving"
        
          :height="150"
          :vuelidate="$v"
          field-name="description"
        />
      </template>
    </div>

    
    <template #title>
      {{ item ? "Vertaling bewerken" : "Vertaling toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"
import FormSelect from "/src/components/Inputs/FormSelect.vue"
import FormRichText from "/src/components/Inputs/FormRichText.vue"

import { required } from "vuelidate/lib/validators"
import table from "src/mixins/tableFieldOptions"

export default {
  mixins: [table],
  components: {
    BootstrapModal,
    FormInput,
    FormSelect,
    FormTextarea,
    FormRichText,
  },
  validations() {
    const validation = {
      lang: {
        required,
      },
      name: {
        required,
      },
    }

    if (!this.simpleTranslation) {
      return {
        ...validation,

        short_description: {
          required,
        },
        description: {
          required,
        },
      }
    }

    return validation
  },
  props: {
    simpleTranslation: Boolean,
    simpleTranslationPlaceholder: String,
    parseTranslationParams: Function,
    
    translation: {
      type: Object,
      required: false,
    },
    endpoint: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    callback: {
      type: Function,
      required: false,
    },
    goBack: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      show: false,
      
      lang: "",
      name: "",
      short_description: "",
      description: "",
    }
  },
  mounted() {
    this.show = true
  },
  created() {
    const item = this.item
    if (item) {
      this.$v.lang.$model = item.lang

      this.$v.name.$model = item.name
      if (!this.simpleTranslation) {
        this.$v.short_description.$model = item.short_description
        this.$v.description.$model = item.description
      }
    }
  },
  methods: {
    close() {
      this.$emit("close")

      this.goBack && this.$nextTick(this.goBack)
    },
    async saveTranslation() {
      this.$v.$touch()
      if (this.$v.$error) return;

      let payload = {
        language: this.$v.lang.$model,
        translation: {
          name: this.$v.name.$model,
          is_autotranslated: false,
        },
      }

      if (!this.simpleTranslation) {
        payload.translation = {
          ...payload.translation,
          short_description: this.$v.short_description.$model,
          description: this.$v.description.$model,
        }
      }

      payload = this.parseTranslationParams ? this.parseTranslationParams(payload) : payload

      await this.$handlePromise(async () => {
        console.log(payload)
        
        if (this.endpoint) {
          await this.axios.post(this.endpoint, payload)
        }

        this.callback && (await this.callback(payload))
        
        this.$success("Vertaling succesvol toegevoegd!")
        this.$emit("close")

        this.goBack && this.$nextTick(this.goBack)
      })
    },
  },
}

</script>

<style scoped>

.AddTranslation {
  flex-basis: 650px;
}

.border-separation {
  border-top: 1px solid #E3E3E3;
}

</style>
